import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import ResponsiveFooter from "../components/Reaponsivefooter";
import BackgroundLottie from "../components/BackgroundLottie";
import { Outlet, useLocation } from "react-router-dom";
import ComboBar from "../components/ComboBar";
import ToastContainer from "../components/Toastcontainer";
import "../App.css";

const MainLayout = () => {
  const location = useLocation();

 
 const showComboBar =
  location.pathname === "/" || location.pathname === "/bsk-home";


  return (
    <>
      <ToastContainer />
      <BackgroundLottie />
      <Header />

      <main className="main-layout-content">
        <Outlet />
      </main>

      {showComboBar && <ComboBar />}

      <Footer />
      <ResponsiveFooter />
    </>
  );
};

export default MainLayout;
